import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import PageHeader from "Component/Headers/pageHeader";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import { ErrorMessages } from "Constants";
import * as FileSaver from "file-saver";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import readXlsxFile from "read-excel-file";
import { getFormattedImageLink, getMonthName, rawDataIntoExcel } from "Utils";
import { getmonthyearonly } from "Utils/dates";
import * as XLSX from "xlsx";

const TEMP = [
  {
    employeename: "Name",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 1",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 2",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
];

export const ExportArrearsXLSX = (props = {}) => {
  const { rows = TEMP, empobjindex = 10, date = "", name = "" } = props;
  const filename = `Lop_Arrears_${getMonthName(name.split("-")[0])}_${
    name.split("-")[1]
  }.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  let header = [
    "empfullname",
    "department",
    "designation",
    "businessunit",
    "lop_1",
  ];
  if (empobjindex == 8 || empobjindex == 10) {
    header = [...header, "loparrears_1", "lop_2"];
  }
  if (empobjindex == 10) {
    header = [...header, "loparrears_2", "lop_3"];
  }
  header = [...header, "employeeobj"];

  const ws = XLSX.utils.json_to_sheet([...rows], {
    header,
    skipHeader: true,
  });
  /* hide employeeid column */
  ws["!cols"] = [];
  ws["!cols"][empobjindex - 1] = { hidden: true };

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

const EXCELCONST = [];

class LeaveEncashment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      fromdate: "",
      selectedEmployee: null,
      List: [],
      filterList: [],
      time1: 0,
      isloading: false,
    };
    this.getdata = this.getdata.bind(this);
    this.onSave = this.onSave.bind(this);
    this.setEmpData = this.setEmpData.bind(this);
  }

  componentDidMount() {
    this.getdata();
  }

  setEmpData(objData) {
    this.setState({
      tempEmpData: objData,
    });
  }

  getdata() {
    const {
      salarycycle,
      payrollcycle,
      isSpeicalCase,
      specialEmps,
      normalEmps,
    } = this.props;

    const disbursementmonthid = get(salarycycle, "payrollmonthid", 12);
    const disbursementyear = get(salarycycle, "payrollyear", 2019);
    const payrollcycleid = get(salarycycle, "payrollcycleid", 4);
    const getDataObj = (arr, employeeid) => {
      const result = arr.find((x) => x.employeeid == employeeid);
      if (result) {
        if (result.lop_1) {
          result.lop_1 = {
            ...result.lop_1,
            payrollmonthyearname: getmonthyearonly(
              get(result, "lop_1.payrollmonthyear", "-"),
            ),
          };
        }
        if (result.lop_2) {
          result.loparrears_1 = {
            ...result.loparrears_1,
            payrollmonthyearname: getmonthyearonly(
              get(result, "loparrears_1.payrollmonthyear", "-"),
            ),
          };
        }

        if (result.lop_2) {
          result.lop_2 = {
            ...result.lop_2,
            payrollmonthyearname: getmonthyearonly(
              get(result, "lop_2.payrollmonthyear", "-"),
            ),
          };
        }

        if (result.lop_3) {
          result.loparrears_2 = {
            ...result.loparrears_2,
            payrollmonthyearname: getmonthyearonly(
              get(result, "loparrears_2.payrollmonthyear", "-"),
            ),
          };
        }

        if (result.lop_3) {
          result.lop_3 = {
            ...result.lop_3,
            payrollmonthyearname: getmonthyearonly(
              get(result, "lop_3.payrollmonthyear", "-"),
            ),
          };
        }
      }
      return result ? result : {};
    };
    const postdata = {
      monthid: disbursementmonthid,
      year: disbursementyear,
      payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", 12),
      salarycycleid: get(salarycycle, "salarycycleid", 12),
      salarycyclesplitid: get(salarycycle, "displayvalue", 12),
      payrollcycleid,
      employeeids: isSpeicalCase
        ? specialEmps.map((x) => x.employeeid)
        : normalEmps.map((x) => x.employeeid),
    };
    instance
      .post("payroll/getemployeeslop", postdata)
      .then((resp1) => {
        const finalres = isSpeicalCase
          ? specialEmps.map((x) => ({
              ...x,
              ...getDataObj(get(resp1, "data.result", []), x.employeeid),
            }))
          : normalEmps.map((x) => ({
              ...x,
              ...getDataObj(get(resp1, "data.result", []), x.employeeid),
            }));
        this.setState({
          empobjindex: get(finalres, "[0].lop_3", "")
            ? 10
            : get(finalres, "[0].lop_2", "")
            ? 8
            : 6,
          List: finalres,
          filterList: finalres,
          tempEmpData: finalres[0],
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async uploadData(e) {
    console.log("e: ", e);
    const { List, empobjindex } = this.state;
    const _file = e.target.files[0];
    console.log("_file: ", _file);
    if (!_file) {
      return;
    }
    const imgname = _file.name;
    let idxDot = "";
    let extFile = "";
    idxDot = imgname.lastIndexOf(".") + 1;
    extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    if (extFile != "xlsx") {
      this.props.enqueueSnackbar("Please select valid file format", {
        variant: "error",
      });
      return;
    }
    try {
      let rows = await readXlsxFile(_file);
      console.log("rows1: ", rows);
      rows = rows
        ? rows.filter(
            (x, i) =>
              i !== 0 &&
              x[0] &&
              x[1] &&
              x[2] &&
              (empobjindex == 6 ? x[5] : true) &&
              (empobjindex == 8 ? x[7] : true) &&
              (empobjindex == 10 ? x[9] : true),
          )
        : [];
      console.log("rows2: ", rows, rows[0]);
      // return;
      if (rows && rows[0]) {
        // rows = rows.slice(0, 1);
        console.log("rows3: ", rows);
        let valid = true;
        const result = [...List].map((x) => {
          if (valid) {
            const getempid = (str) => {
              const res = JSON.parse(str);
              return res.employeeid;
            };
            const thisinput = rows.find(
              (row) => x.employeeid == getempid(row[empobjindex - 1]),
            ) || ["", "", "", "", 0, 0, 0, 0, 0, ""];
            console.log("thisinput: ", thisinput);
            if (isNaN(thisinput[4])) {
              this.props.enqueueSnackbar("Invalid values occured", {
                variant: "error",
              });
              valid = false;
            }
            x = {
              ...x,
              updatedfromexcel: true,
              lop_1: { ...x.lop_1, effectivelop: thisinput[4] },
            };
            if (valid && empobjindex == 10) {
              if (
                isNaN(thisinput[5]) ||
                isNaN(thisinput[6]) ||
                isNaN(thisinput[7]) ||
                isNaN(thisinput[8])
              ) {
                this.props.enqueueSnackbar("Invalid values occured", {
                  variant: "error",
                });
                valid = false;
              }
              x.lop_3 = { ...x.lop_3, effectivelop: thisinput[8] };

              x.lop_2 = { ...x.lop_2, effectivelop: thisinput[6] };
              x.loparrears_2 = {
                ...x.loparrears_2,
                effectiveloparrears: thisinput[7],
              };
              x.loparrears_1 = {
                ...x.loparrears_1,
                effectiveloparrears: thisinput[5],
              };
            } else if (valid && empobjindex == 8) {
              if (isNaN(thisinput[5]) || isNaN(thisinput[6])) {
                this.props.enqueueSnackbar("Invalid values occured", {
                  variant: "error",
                });
                valid = false;
              }
              x.lop_2 = { ...x.lop_2, effectivelop: thisinput[6] };

              x.loparrears_1 = {
                ...x.loparrears_1,
                effectiveloparrears: thisinput[5],
              };
            }
            return x;
          }
          return x;
        });
        if (valid) {
          this.setState({ List: result });
        } else {
          this.props.enqueueSnackbar("Invalid values occured", {
            variant: "error",
          });
          this.setState({ List: [] });
        }
      } else {
        this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
      }
    } catch (error) {
      console.log("error: ", error);
      this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
    }
  }

  onSave() {
    const { salarycycle = null } = this.props;
    const { List, empobjindex } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      const monthid = get(salarycycle, "payrollmonthid", 12);
      const year = get(salarycycle, "payrollyear", 2019);
      const uploadlops = [];
      const uploadlopspostdata = [...List].filter((x) => x.updatedfromexcel);
      uploadlopspostdata.forEach((x) => {
        if (empobjindex == 10) {
          uploadlops.push({
            salarycycleid: get(x, "lop_3.salarycycleid", 0),
            salarycyclesplitid: get(x, "lop_3.salarycyclesplitid", 0),
            payrollcycledurationid: get(x, "lop_3.payrollcycledurationid", 0),
            arrearsmonthid: monthid,
            arrearsyear: year,
            lop: get(x, "lop_3.lop", 0),
            effectivelop: get(x, "lop_3.effectivelop", 0),
            loparrears: get(x, "loparrears_3.loparrears", 0),
            effectiveloparrears: get(x, "loparrears_3.effectiveloparrears", 0),
            iscurrent: get(x, "lop_3.payrollmonthid", "") == monthid,
            employeeid: get(x, "employeeid", ""),
            parentuploadlopid: get(x, "lop_3.parentuploadlopid", ""),
          });
        }
        if (empobjindex == 8 || empobjindex == 10) {
          uploadlops.push({
            salarycycleid: get(x, "lop_2.salarycycleid", 0),
            salarycyclesplitid: get(x, "lop_2.salarycyclesplitid", 0),
            payrollcycledurationid: get(x, "lop_2.payrollcycledurationid", 0),
            arrearsmonthid: monthid,
            arrearsyear: year,
            lop: get(x, "lop_2.lop", 0),
            effectivelop: get(x, "lop_2.effectivelop", 0),
            loparrears: get(x, "loparrears_2.loparrears", 0),
            effectiveloparrears: get(x, "loparrears_2.effectiveloparrears", 0),
            iscurrent: get(x, "lop_2.payrollmonthid", "") == monthid,
            employeeid: get(x, "employeeid", ""),
            parentuploadlopid: get(x, "lop_2.parentuploadlopid", ""),
          });
        }
        uploadlops.push({
          salarycycleid: get(x, "lop_1.salarycycleid", 0),
          salarycyclesplitid: get(x, "lop_1.salarycyclesplitid", 0),
          payrollcycledurationid: get(x, "lop_1.payrollcycledurationid", 0),
          arrearsmonthid: monthid,
          arrearsyear: year,
          lop: get(x, "lop_1.lop", 0),
          effectivelop: get(x, "lop_1.effectivelop", 0),
          loparrears: get(x, "loparrears_1.loparrears", 0),
          effectiveloparrears: get(x, "loparrears_1.effectiveloparrears", 0),
          iscurrent: get(x, "lop_1.payrollmonthid", "") == monthid,
          employeeid: get(x, "employeeid", ""),
          parentuploadlopid: get(x, "lop_1.parentuploadlopid", ""),
        });
      });

      console.log("uploadlops: ", uploadlops);
      // return;
      const totalseconds = uploadlops.length * 3;
      const secondsforintervals = totalseconds * 1000;
      this.interval = setInterval(
        () =>
          this.setState({
            time1: this.state.time1 >= 99 ? 99 : this.state.time1 + 1,
          }),
        secondsforintervals / 100,
      );

      this.setState(
        {
          // time1: 0,
          isloading: true,
        },
        () => {
          instance
            .post("payroll/bulkuploadlop", { uploadlops })
            .then(() => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar("Uploaded successfully", {
                variant: "success",
              });
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.getdata();
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        },
      );
    }
  }

  handleSearch = (e) => {
    const { List, filterList } = this.state;
    const FF = List.filter(
      (item) =>
        item.empfullname.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      List: e.target.value ? FF : filterList,
    });
  };

  ExportData = () => {
    const { List = [], empobjindex = 10 } = this.state;
    const { salarycycle } = this.props;
    console.log("empobjindex: ", empobjindex);
    console.log("List: ", List);
    const unassignedemployees = [...List];
    const headerobj = {
      empfullname: "Name",
      department: "Department",
      designation: "Designation",
      businessunit: "Location",
      lop_1: `LOP for ${get(
        unassignedemployees[0],
        "lop_1.payrollmonthyearname",
        "-",
      )}`,

      employeeobj: "Employee details",
    };

    if (unassignedemployees[0].lop_2) {
      headerobj.loparrears_1 = `LOP Arrears for ${get(
        unassignedemployees[0],
        "loparrears_1.payrollmonthyearname",
        "-",
      )}`;
      headerobj.lop_2 = `LOP for ${get(
        unassignedemployees[0],
        "lop_2.payrollmonthyearname",
        "-",
      )}`;
    }

    if (unassignedemployees[0].lop_3) {
      headerobj.loparrears_2 = `LOP Arrears for ${get(
        unassignedemployees[0],
        "loparrears_2.payrollmonthyearname",
        "-",
      )}`;
      headerobj.lop_3 = `LOP for ${get(
        unassignedemployees[0],
        "lop_3.payrollmonthyearname",
        "-",
      )}`;
    }

    ExportArrearsXLSX({
      rows: [
        headerobj,
        ...unassignedemployees.map((x) => {
          const obj = {
            empfullname: x.empfullname || null,
            department: x.department || null,
            designation: x.designation || null,
            businessunit: x.businessunit || null,
            lop_1: get(x, "lop_1.effectivelop", ""),
            employeeobj: JSON.stringify(x),
          };

          if (x.lop_2) {
            obj.loparrears_1 = get(x, "loparrears_1.effectiveloparrears", "");
            obj.lop_2 = get(x, "lop_2.effectivelop", "");
          }
          if (x.lop_3) {
            obj.loparrears_2 = get(x, "loparrears_2.effectiveloparrears", "");
            obj.lop_3 = get(x, "lop_3.effectivelop", "");
            // obj.loparrears_3 = get(x, "loparrears_3.effectiveloparrears", "");
          }
          console.log("obj: ", obj);
          return obj;
        }),
      ],
      empobjindex,
      name: salarycycle && salarycycle.displayname,
      date: salarycycle
        ? salarycycle.cycleto
        : moment(new Date()).format("YYYY-MM-DD"),
    });
  };

  render() {
    const { List = [], empobjindex = 10, tempEmpData } = this.state;
    // const List = searchValue ? filterList : salarysheet;
    const { setsalaryadjustpage } = this.props;

    return (
      <div className="innerwrapper-full-width">
        <div className="margin-top-4">
          <PageHeader header="Step 3.4: Leave encashment adjustment" />
        </div>
        <p className="normal-dark-secondary margin-bottom-16">
          Select employee and allocate leave encashment, it’s that easy! Click
          Save when you are done.
        </p>

        <Grid container spacing={3} className="margin-top-8 margin-bottom-24">
          <Grid item xs={12} md={3} sm={12}>
            <VerticalTabs
              value={0}
              indicatorColor="primary"
              textColor="primary"
              className="right-border width250 cursurpointer"
            >
              <Paper
                className="rounded-rectangle-paper"
                style={{
                  height: "50vh",
                  boxSizing: "border-box",
                  padding: "0px 8px",
                  background: "#f7f8f8",
                }}
              >
                {List.map((x) => (
                  <div
                    className="rounded-rectangle-div"
                    style={{ margin: "8px 0px" }}
                    onClick={() => this.setEmpData(x)}
                  >
                    <div className="display-flex">
                      <ProfilePictureSmall
                        src={getFormattedImageLink(x.imagepath)}
                        // src=""
                      />
                      <div className="margin-left-16">
                        <p className="small-dark-secondary ellipsis">
                          {x.empfullname}
                        </p>
                        <p className="small-dark-secondary ellipsis">₹ - -</p>
                      </div>
                    </div>
                  </div>
                ))}
              </Paper>
            </VerticalTabs>
          </Grid>
          <Grid item xs={12} md={9} sm={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3} sm={12}></Grid>
              <Grid item xs={12} md={3} sm={12}>
                <p className="small-dark-secondary text-center">Leave count</p>
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <p className="small-dark-secondary text-center">
                  Amount per leave
                </p>
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <p className="small-dark-secondary text-center">Total amount</p>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3} sm={12}>
                <p className="small-dark-secondary t-bold">Casual leave</p>
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: "",
                    label: "",
                    placeholder: "-",
                    // disabled: editable === false ? true : false,
                  })}
                  onChange={(e) => this.updatePostData("duedays", e)}
                  formKey="duedays"
                />
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: "",
                    label: "",
                    placeholder: "-",
                    // disabled: editable === false ? true : false,
                  })}
                  onChange={(e) => this.updatePostData("duedays", e)}
                  formKey="duedays"
                />
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: "",
                    label: "",
                    placeholder: "₹	- -",
                    // disabled: editable === false ? true : false,
                  })}
                  onChange={(e) => this.updatePostData("duedays", e)}
                  formKey="duedays"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} sm={12}>
                <div
                  style={{
                    background: "#f7f8f8",
                    padding: "8px 16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ alignItems: "center", display: "flex" }}>
                    <ProfilePictureSmall
                      // src={getFormattedImageLink(row.imagepath)}
                      src=""
                    />
                    <p className="small-dark margin-left-16 t-bold">
                      Total amount for {tempEmpData && tempEmpData.empfullname}
                    </p>
                  </div>
                  <p className="small-dark t-bold">₹ - -</p>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            sm={12}
            md={12}
            className="display-flex"
            style={{
              background: "#dcf2f1",
              padding: 16,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p className="small-dark t-bold" style={{ color: "#008985" }}>
              Total employees allocated leave encashment
            </p>
            <p className="small-dark t-bold" style={{ color: "#008985" }}>
              Total amount &nbsp; ₹ - -
            </p>
          </Grid>
        </Grid>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                value={this.state.time1}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time1}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 172 }}>
                    <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      onClick={() => setsalaryadjustpage("home")}
                    >
                      Go back
                    </Button>
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <div>
                      <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                        disabled={
                          this.props.SaveInProgressReducer.issaveinprogress
                        }
                        onClick={this.onSave}
                        // onClick={this.analysedData()}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(LeaveEncashment)),
);

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const ExportData = () => {
  const rows = [[].map((y) => y.displayname)];
  const { salarysheet = [] } = this.props;

  salarysheet.forEach((x) => {
    rows.push(EXCELCONST.map((y) => x[y.displayvalue]));
  });

  const csvContent = rawDataIntoExcel(rows);

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "my_data.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
};

const EMPOBJ = {
  employeeid: "",
  lop_1: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 91,
    payrollcycledurationid: 1,
    payrollmonthid: 10,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_1: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 91,
    payrollcycledurationid: 1,
    payrollmonthid: 10,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
  lop_2: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 11,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_2: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 11,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
  lop_3: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 12,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_3: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 93,
    payrollcycledurationid: 1,
    payrollmonthid: 12,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
};
